"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.experimentsSet = exports.uiBodyClassRemove = exports.uiBodyClassAdd = exports.uiScrollToElement = exports.stripeUpdateBillingInfo = exports.stripeUseNewCard = exports.stripeGetSavedCard = exports.stripeSaveCardChange = exports.stripeCreateToken = exports.downloadSetPreviewAttribution = exports.downloadNoPremiumFeatures = exports.downloadResetAttribution = exports.downloadJumpToLicense = exports.downloadRepurchase = exports.downloadUpsell = exports.downloadResetToLicense = exports.downloadUpsellFlow = exports.downloadSelectPurchaseType = exports.downloadPurchase = exports.downloadStartSuccess = exports.downloadStart = exports.downloadShowAuth = exports.downloadRequest = exports.downloadFlowGoBack = exports.downloadSetFlowActive = exports.downloadResetFlow = exports.iconsFetchPurchased = exports.getCurrentUser = exports.dismissModal = exports.showModal = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.saveQueryInfo = saveQueryInfo;
exports.setSearchTerm = setSearchTerm;
exports.fetchAutoCompleteTerms = fetchAutoCompleteTerms;
exports.fetchFeaturedCreators = fetchFeaturedCreators;
exports.toggleFeatureCreator = toggleFeatureCreator;
exports.fetchFortCollection = fetchFortCollection;
exports.previewCollectionIcons = previewCollectionIcons;
exports.saveCollection = saveCollection;
exports.disableCollection = disableCollection;
exports.featureCollection = featureCollection;
exports.unFeatureCollection = unFeatureCollection;
exports.fetchFeaturedCollectionMetaData = fetchFeaturedCollectionMetaData;
exports.fetchHeroIcon = fetchHeroIcon;
exports.fetchCollection = fetchCollection;
exports.fetchCollectionIcons = fetchCollectionIcons;
exports.searchCreatorUploads = searchCreatorUploads;
exports.searchCreatorIcons = searchCreatorIcons;
exports.searchCollectionIcons = searchCollectionIcons;
exports.searchTerm = searchTerm;
exports.searchIcons = searchIcons;
exports.fetchViewMoreIcons = fetchViewMoreIcons;
exports.fetchIcons = fetchIcons;
exports.fetchIcon = fetchIcon;
exports.fetchSVGData = fetchSVGData;
exports.placePluginSVG = placePluginSVG;
exports.saveCleanedSVG = saveCleanedSVG;
exports.setActiveIcon = setActiveIcon;
exports.clearActiveIcon = clearActiveIcon;
exports.getIconMetaData = getIconMetaData;
exports.setColor = setColor;
exports.setSize = setSize;
exports.toggleIconDetail = toggleIconDetail;
exports.fetchRecentIcons = fetchRecentIcons;
exports.fetchBestCollectionIcons = fetchBestCollectionIcons;
exports.fetchFeaturedCollection = fetchFeaturedCollection;
exports.logOut = logOut;
exports.login = login;
exports.signup = signup;
exports.createStripeToken = createStripeToken;
exports.saveCreditCard = saveCreditCard;
exports.upgradeToProAccount = upgradeToProAccount;
exports.fetchCreator = fetchCreator;
exports.disableCreator = disableCreator;
exports.suspendCreator = suspendCreator;
exports.unSuspendCreator = unSuspendCreator;
exports.fetchSavedUploads = fetchSavedUploads;
exports.fetchNewUploads = fetchNewUploads;
exports.fetchSuspendedUploads = fetchSuspendedUploads;
exports.fetchUploadIcons = fetchUploadIcons;
exports.fetchContinueUploadIcons = fetchContinueUploadIcons;
exports.previewUploadIcons = previewUploadIcons;
exports.searchUploads = searchUploads;
exports.searchSavedUploads = searchSavedUploads;
exports.searchSuspendedUploads = searchSuspendedUploads;
exports.rateCreator = rateCreator;
exports.reviewUpload = reviewUpload;
exports.completeUpload = completeUpload;
exports.saveBatchForLater = saveBatchForLater;
exports.saveCreatorNote = saveCreatorNote;
exports.selectIcon = selectIcon;
exports.deselectIcon = deselectIcon;
exports.selectAllIcons = selectAllIcons;
exports.unselectAllIcons = unselectAllIcons;
exports.getTotalIconCount = getTotalIconCount;
exports.fetchFortIcon = fetchFortIcon;
exports.approveIcons = approveIcons;
exports.saveFortIconInfo = saveFortIconInfo;
exports.regenerateIcon = regenerateIcon;
exports.disableIcon = disableIcon;
exports.denyIcons = denyIcons;
exports.denialReasons = denialReasons;
exports.featureIcon = featureIcon;
exports.unFeatureIcon = unFeatureIcon;
exports.saveName = saveName;
exports.saveTags = saveTags;
exports.setAdobeAgent = setAdobeAgent;
exports.reportPluginUsage = reportPluginUsage;
exports.setPage = setPage;
exports.setPluginHost = setPluginHost;
exports.placePluginPNGGSuite = placePluginPNGGSuite;
exports.placePluginPDF = placePluginPDF;
exports.placePluginPNG = placePluginPNG;
exports.pluginIcons = pluginIcons;
exports.sendEduApplication = sendEduApplication;
exports.downloadSelectLicense = downloadSelectLicense;
exports.downloadCommitLicense = downloadCommitLicense;
exports.downloadSelectAttribution = downloadSelectAttribution;
exports.downloadCommitAttribution = downloadCommitAttribution;
exports.downloadPurchaseStart = downloadPurchaseStart;
exports.downloadPurchaseEnd = downloadPurchaseEnd;
exports.stripeCreateTokenStart = stripeCreateTokenStart;
exports.stripeCreateTokenSuccess = stripeCreateTokenSuccess;
exports.stripeCreateTokenFailure = stripeCreateTokenFailure;
exports.stripeCardInputChange = stripeCardInputChange;
exports.stripeCardInputError = stripeCardInputError;

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _api = require("../middleware/api");

var _download = require("../reducers/download");

var _download2 = require("../helpers/download");

var _download3 = _interopRequireDefault(_download2);

var _callApiPromise = require("../helpers/call-api-promise");

var _callApiPromise2 = _interopRequireDefault(_callApiPromise);

var _dispatcher = require("../legacy/dispatcher/dispatcher");

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _isEmpty = require("lodash/isEmpty");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isRegExp = require("lodash/isRegExp");

var _isRegExp2 = _interopRequireDefault(_isRegExp);

var _raven_client = require("../legacy/helpers/raven_client");

var _raven_client2 = _interopRequireDefault(_raven_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Redux action creators live here. Read Redux docs for more information:
 * http://redux.js.org/docs/basics/Actions.html
 */

var actionTypes = require("./actionTypes");

var Schemas = require("../middleware/api").Schemas;

// Fetch actions use API middleware to abstract loading & normalizing data, and handling errors.

// show / dismiss modals

var showModal = exports.showModal = function showModal(e, component, props) {
    return function (dispatch, getState) {
        if (e) e.preventDefault();

        var _getState = getState(),
            modal = _getState.modal;

        var currentModal = modal.component;

        if (currentModal) {
            dispatch(dismissModal());
        }

        return new Promise(function (resolve, reject) {
            props = Object.assign({}, props, {
                onDismiss: resolve
            });

            dispatch(uiBodyClassAdd("modal-activated", "modal-" + component.toLowerCase()));
            dispatch({
                type: actionTypes.SHOW_MODAL,
                component: component,
                props: props
            });
        });
    };
};

var dismissModal = exports.dismissModal = function dismissModal(component, msg) {
    return function (dispatch, getState) {
        var _getState2 = getState(),
            modal = _getState2.modal;

        if (component) {
            var toRemove = ["modal-" + component.toLowerCase()];
            if (modal.all && Object.keys(modal.all).length == 1) {
                toRemove.push("modal-activated");
            }

            var dismissed = modal.all[component];

            if (dismissed) {
                var childProps = dismissed.props;
                if (childProps.onDismiss) {
                    childProps.onDismiss(msg);
                }
            }

            dispatch(uiBodyClassRemove.apply(undefined, toRemove));
        } else {
            dispatch(uiBodyClassRemove(/modal-/));
        }
        dispatch({
            type: actionTypes.DISMISS_MODAL,
            component: component
        });
    };
};

// search

function saveQueryInfo(queryInfo) {
    return {
        queryInfo: queryInfo,
        type: actionTypes.SAVE_QUERY_INFO
    };
}

function setSearchTerm(searchQuery) {
    return {
        query: searchQuery,
        type: actionTypes.SET_SEARCH_QUERY
    };
}

function fetchAutoCompleteTerms(searchQuery) {
    return _defineProperty({
        searchQuery: searchQuery
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_AUTOCOMPLETE_TERMS, actionTypes.FETCH_AUTOCOMPLETE_TERMS_SUCCESS, actionTypes.FETCH_AUTOCOMPLETE_TERMS_FAILURE],
        endpoint: "json_icon_list/autocomplete/?term=" + searchQuery,
        schema: Schemas.SEARCH,
        method: "GET",
        service: "www"
    });
}

// creators

function fetchFeaturedCreators(id) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var limit = 6;

    if (page === 1) {
        limit = 9;
    }
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_FEATURED_CREATORS, actionTypes.FETCH_FEATURED_CREATORS_SUCCESS, actionTypes.FETCH_FEATURED_CREATORS_FAILURE],
        endpoint: "featured/users/?limit=" + limit + "&page=" + page,
        schema: Schemas.CREATOR,
        method: "GET",
        id: id,
        page: page,
        service: "www"
    });
}

function toggleFeatureCreator(creator, status) {
    return _defineProperty({
        creator_id: creator.id,
        status: status
    }, _api.CALL_API, {
        types: [actionTypes.TOGGLE_FEATURE_CREATOR, actionTypes.TOGGLE_FEATURE_CREATOR_SUCCESS, actionTypes.TOGGLE_FEATURE_CREATOR_FAILURE],
        endpoint: "featured/users/",
        data: {
            users: [{
                id: creator.id,
                status: status
            }]
        },
        schema: Schemas.CREATOR,
        method: "POST",
        service: "api"
    });
}

// collections

function fetchFortCollection(collection_id) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_FORT_COLLECTION, actionTypes.FETCH_FORT_COLLECTION_SUCCESS, actionTypes.FETCH_FORT_COLLECTION_FAILURE],
        endpoint: "fort/collection/" + collection_id + "/?icon_count=10000000",
        schema: Schemas.COLLECTIONS,
        method: "GET",
        service: "api"
    });
}

function previewCollectionIcons(iconKeys, collection_id) {
    return _defineProperty({
        collection_id: collection_id
    }, _api.CALL_API, {
        types: [actionTypes.PREVIEW_COLLECTION_ICONS, actionTypes.PREVIEW_COLLECTION_ICONS_SUCCESS, actionTypes.PREVIEW_COLLECTION_ICONS_FAILURE],
        endpoint: "fort/json_icons/",
        data: {
            icons: iconKeys
        },
        schema: Schemas.ICONS,
        method: "POST",
        service: "www"
    });
}

function saveCollection(collection) {
    return _defineProperty({
        collection_id: collection.id
    }, _api.CALL_API, {
        types: [actionTypes.SAVE_COLLECTION, actionTypes.SAVE_COLLECTION_SUCCESS, actionTypes.SAVE_COLLECTION_FAILURE],
        endpoint: "fort/collections/" + collection.id + "/edit/",
        data: {
            icons: collection.iconKeys,
            name: collection.name
        },
        schema: Schemas.COLLECTIONS,
        method: "POST",
        service: "www"
    });
}

function disableCollection(collection) {
    return _defineProperty({
        collection_id: collection.id
    }, _api.CALL_API, {
        types: [actionTypes.DISABLE_COLLECTION, actionTypes.DISABLE_COLLECTION_SUCCESS, actionTypes.DISABLE_COLLECTION_FAILURE],
        endpoint: "fort/collections/" + collection.id + "/",
        data: {},
        schema: Schemas.COLLECTIONS,
        method: "POST",
        service: "www"
    });
}

function featureCollection(collectionType, collectionID) {
    if (collectionType === "upload") {
        return {
            type: actionTypes.FEATURE_COLLECTION
        };
    } else {
        return _defineProperty({
            collection_id: collectionID
        }, _api.CALL_API, {
            types: [actionTypes.FEATURE_COLLECTION, actionTypes.FEATURE_COLLECTION_SUCCESS, actionTypes.FEATURE_COLLECTION_FAILURE],
            data: {
                collections: [{
                    id: collectionID,
                    status: "add"
                }]
            },
            endpoint: "featured/collections/",
            method: "POST",
            service: "api"
        });
    }
}

function unFeatureCollection(collectionType, collectionID) {
    if (collectionType === "upload") {
        return {
            type: actionTypes.UNFEATURE_COLLECTION
        };
    } else {
        return _defineProperty({
            collection_id: collectionID
        }, _api.CALL_API, {
            types: [actionTypes.UNFEATURE_COLLECTION, actionTypes.UNFEATURE_COLLECTION_SUCCESS, actionTypes.UNFEATURE_COLLECTION_FAILURE],
            data: {
                collections: [{
                    id: collectionID,
                    status: "remove"
                }]
            },
            endpoint: "featured/collections/",
            method: "POST",
            service: "api"
        });
    }
}

function fetchFeaturedCollectionMetaData() {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_FEATURED_COLLECTIONS_METADATA, actionTypes.FETCH_FEATURED_COLLECTIONS_METADATA_SUCCESS, actionTypes.FETCH_FEATURED_COLLECTIONS_METADATA_FAILURE],
        endpoint: "featured/collections/?limit=5",
        schema: Schemas.COLLECTIONS,
        method: "GET",
        service: "www"
    });
}

// icons

function fetchHeroIcon(iconId) {
    return _defineProperty({
        icon_id: iconId
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_HERO_ICON, actionTypes.FETCH_HERO_ICON_SUCCESS, actionTypes.FETCH_HERO_ICON_FAILURE],
        endpoint: "json_icon_plugin/" + iconId + "/",
        schema: Schemas.ICONS,
        method: "GET",
        service: "www"
    });
}

function fetchCollection(collectionId) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var maxIcons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 72;

    return _defineProperty({
        collectionId: collectionId,
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: "json_icon_list/collections/?response=icons_response&id=" + collectionId + "&page=" + page + "&limit=" + maxIcons + "&raw_html=false",
        schema: Schemas.ICONS,
        id: "collectionIcon",
        page: page,
        method: "GET",
        service: "www"
    });
}

function fetchCollectionIcons(collectionId) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var maxIcons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 72;

    return _defineProperty({
        collectionId: collectionId
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS_ICONS, actionTypes.SEARCH_ICONS_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_ICONS_FAILURE],
        endpoint: "json_icon_list/collections/?response=icons_response&id=" + collectionId + "&page=" + page + "&limit=" + maxIcons + "&raw_html=false",
        schema: Schemas.ICONS,
        method: "GET",
        service: "www"
    });
}

function searchCreatorUploads(creator) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 72;

    return _defineProperty({
        apiResponse: true,
        creator: creator
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: creator + "/uploads/json/?page=" + page + "&limit=" + limit + "&raw_html=false",
        schema: Schemas.ICONS,
        id: "userUploads",
        page: page,
        method: "GET",
        service: "www"
    });
}

function searchCreatorIcons(searchQuery, creator) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 72;

    return _defineProperty({
        searchQuery: searchQuery,
        apiResponse: true,
        creator: creator
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: "search/json/icon/?q=" + searchQuery + "&creator=" + creator + "&page=" + page + "&limit=" + limit + "&raw_html=false",
        schema: Schemas.ICONS,
        id: "userIcons",
        page: page,
        method: "GET",
        service: "www"
    });
}

function searchCollectionIcons(searchQuery, collection) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 72;

    return _defineProperty({
        searchQuery: searchQuery,
        apiResponse: true,
        collection: collection
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: "search/json/icon/?q=" + searchQuery + "&collection=" + collection + "&page=" + page + "&limit=" + limit + "&raw_html=false",
        schema: Schemas.ICONS,
        id: "collectionIcons",
        page: page,
        method: "GET",
        service: "www"
    });
}

function searchTerm(searchTerm) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 72;

    return _defineProperty({
        searchTerm: searchTerm,
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: "json_icon_list/" + searchTerm + "/?page=" + page + "&limit=" + limit + "&raw_html=false",
        schema: Schemas.ICONS,
        id: searchTerm,
        page: page,
        method: "GET",
        service: "www"
    });
}

function searchIcons(searchQuery) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 72;

    return _defineProperty({
        searchQuery: searchQuery,
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: "search/json/icon/?q=" + searchQuery + "&page=" + page + "&limit=" + limit + "&raw_html=false",
        schema: Schemas.ICONS,
        id: searchQuery,
        page: page,
        method: "GET",
        service: "www"
    });
}

function fetchViewMoreIcons(iconId) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    return _defineProperty({
        apiResponse: true,
        iconId: iconId
    }, _api.CALL_API, {
        id: iconId,
        types: [actionTypes.FETCH_VIEW_MORE_ICONS, actionTypes.FETCH_VIEW_MORE_ICONS_SUCCESS, actionTypes.FETCH_VIEW_MORE_ICONS_FAILURE],
        endpoint: "search/view-more-this/" + iconId + "/?limit=" + limit + "&offset=" + offset,
        schema: Schemas.ICONS,
        offset: offset,
        method: "GET",
        service: "www"
    });
}

function fetchIcons(searchQuery) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return _defineProperty({
        searchQuery: searchQuery,
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_ICONS, actionTypes.FETCH_ICONS_SUCCESS, actionTypes.FETCH_ICONS_FAILURE],
        endpoint: "plugin_search/?query=" + searchQuery + "&page=" + page,
        schema: Schemas.ICONS,
        method: "GET",
        service: "www"
    });
}

function fetchIcon(iconId) {
    return _defineProperty({
        iconId: iconId
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_ICON, actionTypes.FETCH_ICON_SUCCESS, actionTypes.FETCH_ICON_FAILURE],
        endpoint: "json_icon_plugin/" + iconId + "/",
        schema: Schemas.ICONS,
        method: "GET",
        service: "www"
    });
}

function fetchSVGData(iconURL, iconId, attribution) {
    var _ref22;

    return _ref22 = {
        iconId: iconId
    }, _defineProperty(_ref22, _api.CALL_API, {
        types: [actionTypes.FETCH_SVG_DATA, actionTypes.FETCH_SVG_DATA_SUCCESS, actionTypes.FETCH_SVG_DATA_FAILURE],
        endpoint: iconURL,
        method: "GET",
        service: "raw"
    }), _defineProperty(_ref22, _api.DECORATE_ACTIONS, {
        attribution: attribution
    }), _ref22;
}

function placePluginSVG(icon, selectedColor, imgSize) {
    return _defineProperty({
        icon: icon,
        selectedColor: selectedColor,
        imgSize: imgSize
    }, _api.CALL_API, {
        types: [actionTypes.PLACE_SVG_FROM_ICONLIST, actionTypes.PLACE_SVG_FROM_ICONLIST_SUCCESS, actionTypes.PLACE_SVG_FROM_ICONLIST_FAILURE],
        endpoint: icon.icon_url,
        method: "GET",
        service: "raw"
    });
}

function saveCleanedSVG(cleanedSVGData) {
    return {
        cleanedSVGData: cleanedSVGData,
        type: actionTypes.SAVE_CLEANED_SVG
    };
}

function setActiveIcon(iconId) {
    return {
        icon_id: iconId,
        type: actionTypes.SET_ACTIVE_ICON
    };
}

function clearActiveIcon(iconId) {
    return {
        type: actionTypes.CLEAR_ACTIVE_ICON
    };
}

function getIconMetaData() {
    return {
        type: actionTypes.GET_ICON_META_DATA
    };
}

function setColor(colorPalette) {
    return {
        color: colorPalette,
        type: actionTypes.SET_ICON_COLOR_PALETTE
    };
}

function setSize(imgChoices) {
    return {
        imgChoices: imgChoices,
        type: actionTypes.SET_ICON_SIZE
    };
}

function toggleIconDetail(action, icon) {
    if (action === "show") {
        return {
            type: actionTypes.SHOW_ICON_DETAIL
        };
    } else {
        return {
            type: actionTypes.HIDE_ICON_DETAIL
        };
    }
}

function fetchRecentIcons() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 72;
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return _defineProperty({
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: "json_icon_list/recent_uploads/?page=" + page + "&limit=" + limit,
        schema: Schemas.ICONS,
        page: page,
        id: "recent",
        method: "GET",
        service: "www"
    });
}

function fetchBestCollectionIcons() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 36;
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return _defineProperty({
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_BEST_COLLECTIONS, actionTypes.FETCH_BEST_COLLECTIONS_SUCCESS, actionTypes.FETCH_BEST_COLLECTIONS_FAILURE],
        endpoint: "featured/icons/?page=" + page + "&limit=" + limit,
        schema: Schemas.ICONS,
        page: page,
        id: "browse",
        method: "GET",
        service: "www"
    });
}

function fetchFeaturedCollection(collectionId) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var maxIcons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 72;

    return _defineProperty({
        collectionId: collectionId
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_FEATURED_COLLECTIONS, actionTypes.FETCH_FEATURED_COLLECTIONS_SUCCESS, actionTypes.FETCH_FEATURED_COLLECTIONS_FAILURE],
        endpoint: "json_icon_list/collections/?response=icons_response&id=" + collectionId + "&page=" + page + "&limit=" + maxIcons + "&raw_html=false",
        schema: Schemas.ICONS,
        method: "GET",
        service: "www"
    });
}

// user

function logOut(logoutNextUrl) {
    // hack to get logout redirect working without subclassing logout all
    (0, _jquery2.default)("#logout-form").attr("action", "/logout/?next=" + logoutNextUrl);
    (0, _jquery2.default)("#logout-form").submit();

    return {
        type: actionTypes.LOGOUT_USER
    };
}

var getCurrentUser = exports.getCurrentUser = function getCurrentUser() {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.GET_CURRENT_USER, actionTypes.GET_CURRENT_USER_SUCCESS, actionTypes.GET_CURRENT_USER_FAILURE],
        endpoint: "accounts/current-user/",
        schema: Schemas.USER,
        method: "GET",
        data: {},
        service: "www"
    });
};

function login(formData) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.LOGIN, actionTypes.LOGIN_SUCCESS, actionTypes.LOGIN_FAILURE],
        endpoint: "accounts/login/",
        method: "POST",
        formData: formData,
        service: "www"
    });
}

function signup(formData) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.SIGNUP, actionTypes.SIGNUP_SUCCESS, actionTypes.SIGNUP_FAILURE],
        endpoint: "accounts/signup/",
        method: "POST",
        formData: formData,
        service: "www"
    });
}

function createStripeToken(card, user) {
    // Sends customer's card data to stripe & gets token
    // Relies on stripeToken middleware to make stripe call
    return {
        type: actionTypes.CREATE_STRIPE_TOKEN,
        user: user,
        card: card
    };
}

function saveCreditCard(user, stripeToken, receiptInfo) {
    var data = {};

    if (stripeToken) {
        data.stripe_token = stripeToken;
    }

    if (receiptInfo) {
        data.receipt_info = receiptInfo;
    }

    return _defineProperty({
        userId: user.id
    }, _api.CALL_API, {
        types: [actionTypes.SAVE_CARD, actionTypes.SAVE_CARD_SUCCESS, actionTypes.SAVE_CARD_FAILURE],
        endpoint: user.username + "/card/update/",
        method: "POST",
        data: data,
        schema: Schemas.USER,
        service: "www"
    });
}

function upgradeToProAccount(user, stripeToken) {
    var plan = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "pro-yearly";

    return _defineProperty({
        userId: user.id
    }, _api.CALL_API, {
        types: [actionTypes.UPGRADE_BILLING, actionTypes.UPGRADE_BILLING_SUCCESS, actionTypes.UPGRADE_BILLING_FAILURE],
        endpoint: user.username + "/subscribe/pro/",
        method: "POST",
        formData: "stripe_token=" + stripeToken + "&company_name=&vat=&plan=" + plan + "&coupon=",
        schema: Schemas.USER,
        service: "www"
    });
}

var iconsFetchPurchased = exports.iconsFetchPurchased = function iconsFetchPurchased() {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.ICONS_FETCH_PURCHASED, actionTypes.ICONS_FETCH_PURCHASED_SUCCESS, actionTypes.ICONS_FETCH_PURCHASED_FAILURE],
        endpoint: "accounts/purchased_icon_ids/",
        method: "GET",
        service: "www"
    });
};

// creators

function fetchCreator(userId) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_CREATOR, actionTypes.FETCH_CREATOR_SUCCESS, actionTypes.FETCH_CREATOR_FAILURE],
        endpoint: "fort/user/id/" + userId + "/?creator=1&subscriptions=1&organizations=1",
        schema: Schemas.CREATOR,
        method: "GET",
        service: "api"
    });
}

function disableCreator(userId) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.DISABLE_CREATOR, actionTypes.DISABLE_CREATOR_SUCCESS, actionTypes.DISABLE_CREATOR_FAILURE],
        endpoint: "fort/members/disable/" + userId + "/",
        method: "POST",
        data: {},
        service: "www"
    });
}

function suspendCreator(userId, reason) {
    return _defineProperty({
        reason: reason
    }, _api.CALL_API, {
        types: [actionTypes.SUSPEND_CREATOR, actionTypes.SUSPEND_CREATOR_SUCCESS, actionTypes.SUSPEND_CREATOR_FAILURE],
        endpoint: "moderation/suspend/",
        schema: Schemas.CREATOR,
        method: "POST",
        data: {
            user_id: userId,
            reason: reason
        },
        id: userId,
        notifyModal: true,
        service: "api"
    });
}

function unSuspendCreator(userId, reason) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.UNSUSPEND_CREATOR, actionTypes.UNSUSPEND_CREATOR_SUCCESS, actionTypes.UNSUSPEND_CREATOR_FAILURE],
        endpoint: "moderation/unsuspend/",
        schema: Schemas.CREATOR,
        method: "POST",
        data: {
            user_id: userId
        },
        id: userId,
        service: "api"
    });
}

// Uploads

// fetching uploads

function fetchSavedUploads(id) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var uploadsPerPage = 10;
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_SAVED_UPLOADS, actionTypes.FETCH_SAVED_UPLOADS_SUCCESS, actionTypes.FETCH_SAVED_UPLOADS_FAILURE],
        endpoint: "moderation/view/saved/?page=" + page + "&limit=" + uploadsPerPage,
        schema: Schemas.UPLOAD,
        method: "GET",
        id: id,
        page: page,
        service: "api"
    });
}

function fetchNewUploads(id) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var uploadsPerPage = 10;
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_NEW_UPLOADS, actionTypes.FETCH_NEW_UPLOADS_SUCCESS, actionTypes.FETCH_NEW_UPLOADS_FAILURE],
        endpoint: "moderation/view/new/?page=" + page + "&limit=" + uploadsPerPage,
        schema: Schemas.UPLOAD,
        method: "GET",
        id: id,
        page: page,
        service: "api"
    });
}

function fetchSuspendedUploads(id) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var uploadsPerPage = 10;
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_SUSPENDED_UPLOADS, actionTypes.FETCH_SUSPENDED_UPLOADS_SUCCESS, actionTypes.FETCH_SUSPENDED_UPLOADS_FAILURE],
        endpoint: "moderation/view/suspended/?page=" + page + "&limit=" + uploadsPerPage,
        schema: Schemas.UPLOAD,
        method: "GET",
        id: id,
        page: page,
        service: "api"
    });
}

function fetchUploadIcons(id) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var iconsPerPage = 24;
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_UPLOAD_ICONS, actionTypes.FETCH_UPLOAD_ICONS_SUCCESS, actionTypes.FETCH_UPLOAD_ICONS_FAILURE],
        endpoint: "moderation/view/active/?page=" + page + "&limit=" + iconsPerPage,
        schema: Schemas.UPLOAD,
        method: "GET",
        id: id,
        page: page,
        service: "api"
    });
}

function fetchContinueUploadIcons(id) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var iconsPerPage = 24;
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_UPLOAD_ICONS, actionTypes.FETCH_UPLOAD_ICONS_SUCCESS, actionTypes.FETCH_UPLOAD_ICONS_FAILURE],
        endpoint: "moderation/view/active/continue/?page=" + page + "&limit=" + iconsPerPage,
        schema: Schemas.UPLOAD,
        method: "GET",
        id: id,
        page: page,
        service: "api"
    });
}

function previewUploadIcons(uploadId, id) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    var iconsPerPage = 24;
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.PREVIEW_UPLOAD_ICONS, actionTypes.PREVIEW_UPLOAD_ICONS_SUCCESS, actionTypes.PREVIEW_UPLOAD_ICONS_FAILURE],
        endpoint: "moderation/view/" + uploadId + "/?page=" + page + "&limit=" + iconsPerPage,
        schema: Schemas.UPLOAD,
        method: "GET",
        id: id,
        page: page,
        service: "api"
    });
}

// search uploads

function searchUploads(searchTerm) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.SEARCH_UPLOADS, actionTypes.SEARCH_UPLOADS_SUCCESS, actionTypes.SEARCH_UPLOADS_FAILURE],
        endpoint: "moderation/search/new/?query=" + searchTerm,
        schema: Schemas.UPLOAD,
        method: "GET",
        service: "api"
    });
}

function searchSavedUploads(searchTerm) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.SEARCH_SAVED_UPLOADS, actionTypes.SEARCH_SAVED_UPLOADS_SUCCESS, actionTypes.SEARCH_SAVED_UPLOADS_FAILURE],
        endpoint: "moderation/search/saved/?query=" + searchTerm,
        schema: Schemas.UPLOAD,
        method: "GET",
        service: "api"
    });
}

function searchSuspendedUploads(searchTerm) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.SEARCH_SUSPENDED_UPLOADS, actionTypes.SEARCH_SUSPENDED_UPLOADS_SUCCESS, actionTypes.SEARCH_SUSPENDED_UPLOADS_FAILURE],
        endpoint: "moderation/search/suspended/?query=" + searchTerm,
        schema: Schemas.UPLOAD,
        method: "GET",
        service: "api"
    });
}

// rating creator

function rateCreator(user_id, rating) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.RATE_CREATOR, actionTypes.RATE_CREATOR_SUCCESS, actionTypes.RATE_CREATOR_FAILURE],
        endpoint: "moderation/rate/",
        method: "POST",
        data: {
            user_id: user_id,
            points: rating
        },
        service: "api"
    });
}

// updating uploads

function reviewUpload(uploadId) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.REVIEW_UPLOAD, actionTypes.REVIEW_UPLOAD_SUCCESS, actionTypes.REVIEW_UPLOAD_FAILURE],
        endpoint: "moderation/update/" + uploadId + "/",
        schema: Schemas.UPLOAD,
        method: "POST",
        data: {
            status: "active"
        },
        notifyModal: true,
        service: "api"
    });
}

function completeUpload(uploadId) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.COMPLETE_UPLOAD, actionTypes.COMPLETE_UPLOAD_SUCCESS, actionTypes.COMPLETE_UPLOAD_FAILURE],
        endpoint: "moderation/update/" + uploadId + "/",
        schema: Schemas.UPLOAD,
        method: "POST",
        data: {
            status: "complete"
        },
        notifyModal: true,
        service: "api"
    });
}

function saveBatchForLater(uploadId) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.SAVE_UPLOAD_FOR_LATER, actionTypes.SAVE_UPLOAD_FOR_LATER_SUCCESS, actionTypes.SAVE_UPLOAD_FOR_LATER_FAILURE],
        endpoint: "moderation/update/" + uploadId + "/",
        schema: Schemas.UPLOAD,
        method: "POST",
        data: {
            status: "saved"
        },
        notifyModal: true,
        service: "api"
    });
}

function saveCreatorNote(creator, important) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.SAVE_CREATOR_NOTE, actionTypes.SAVE_CREATOR_NOTE_SUCCESS, actionTypes.SAVE_CREATOR_NOTE_FAILURE],
        endpoint: "moderation/notes/",
        method: "POST",
        data: {
            user_id: creator.id,
            notes: creator.note,
            important: important
        },
        notifyModal: true,
        service: "api"
    });
}

// selecting uploads

function selectIcon(icon_upload_id) {
    return {
        type: actionTypes.SELECT_ICON,
        icon_upload_id: icon_upload_id
    };
}

function deselectIcon(icon_upload_id) {
    return {
        type: actionTypes.DESELECT_ICON,
        icon_upload_id: icon_upload_id
    };
}

function selectAllIcons() {
    return {
        type: actionTypes.SELECT_ALL_ICONS
    };
}

function unselectAllIcons() {
    return {
        type: actionTypes.UNSELECT_ALL_ICONS
    };
}

// Icons

function getTotalIconCount() {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_TOTAL_ICON_COUNT, actionTypes.FETCH_TOTAL_ICON_COUNT_SUCCESS, actionTypes.FETCH_TOTAL_ICON_COUNT_FAILURE],
        endpoint: "count/icons/",
        method: "GET",
        service: "www"
    });
}

function fetchFortIcon(iconId) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_FORT_ICON, actionTypes.FETCH_FORT_ICON_SUCCESS, actionTypes.FETCH_FORT_ICON_FAILURE],
        endpoint: "fort/json_fort_icon/" + iconId + "/?png=1200",
        schema: Schemas.ICONS,
        method: "GET",
        service: "www"
    });
}

function approveIcons(upload) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.APPROVE_ICONS, actionTypes.APPROVE_ICONS_SUCCESS, actionTypes.APPROVE_ICONS_FAILURE],
        endpoint: "moderation/uploads/",
        method: "POST",
        data: {
            uploads: upload.map(function (icon) {
                return {
                    id: parseInt(icon.id),
                    status: "approved",
                    json: {
                        tags: Object.keys(icon.tags).map(function (key) {
                            return icon.tags[key];
                        }),
                        term: icon.name
                    },
                    feature_collection: icon.feature_collection,
                    feature_icon: icon.feature_icon
                };
            })
        },
        service: "api"
    });
}

function saveFortIconInfo(icon) {
    return _defineProperty({
        icon_id: icon.id
    }, _api.CALL_API, {
        types: [actionTypes.SAVE_ICON_INFO, actionTypes.SAVE_ICON_INFO_SUCCESS, actionTypes.SAVE_ICON_INFO_FAILURE],
        endpoint: "fort/icon/edit/" + icon.id + "/",
        method: "POST",
        data: {
            id: parseInt(icon.id),
            term: icon.term,
            tags: icon.tags
        },
        schema: Schemas.ICON,
        service: "www"
    });
}

function regenerateIcon(icon) {
    return _defineProperty({
        icon_id: icon.id
    }, _api.CALL_API, {
        types: [actionTypes.REGENERATE_ICON_INFO, actionTypes.REGENERATE_ICON_INFO_SUCCESS, actionTypes.REGENERATE_ICON_INFO_FAILURE],
        endpoint: "fort/icon/generate/" + icon.id + "/",
        data: {},
        method: "POST",
        service: "www"
    });
}

function disableIcon(icon) {
    return _defineProperty({
        icon_id: icon.id
    }, _api.CALL_API, {
        types: [actionTypes.DISABLE_ICON, actionTypes.DISABLE_ICON_SUCCESS, actionTypes.DISABLE_ICON_FAILURE],
        endpoint: "json_disable_icon/" + icon.id + "/",
        data: {},
        method: "POST",
        service: "www"
    });
}

function denyIcons(upload, reason) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.DENY_ICONS, actionTypes.DENY_ICONS_SUCCESS, actionTypes.DENY_ICONS_FAILURE],
        endpoint: "moderation/uploads/",
        method: "POST",
        data: {
            uploads: upload.map(function (icon) {
                return {
                    id: parseInt(icon.id),
                    status: "denied",
                    json: {
                        reason: reason
                    }
                };
            })
        },
        notifyModal: true,
        service: "api"
    });
}

function denialReasons() {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.DENIAL_REASONS, actionTypes.DENIAL_REASONS_SUCCESS, actionTypes.DENIAL_REASONS_FAILURE],
        endpoint: "moderation/reasons/",
        method: "GET",
        service: "api"
    });
}

function featureIcon(iconType, icon_id) {
    if (iconType !== "upload") {
        var _ref59;

        // icon has been approved
        return _ref59 = {}, _defineProperty(_ref59, _api.CALL_API, {
            types: [actionTypes.FEATURE_ICON, actionTypes.FEATURE_ICON_SUCCESS, actionTypes.FEATURE_ICON_FAILURE],
            data: {
                icons: [{
                    id: icon_id,
                    status: "add"
                }]
            },
            endpoint: "featured/icons/",
            method: "POST",
            service: "api"
        }), _defineProperty(_ref59, "icon_upload_id", icon_id), _ref59;
    } else {
        // icon is an upload so we will save it's featured status when it's approved, just update UI
        return {
            type: actionTypes.FEATURE_ICON,
            icon_upload_id: icon_id
        };
    }
}

function unFeatureIcon(iconType, icon_id) {
    if (iconType !== "upload") {
        var _ref60;

        return _ref60 = {}, _defineProperty(_ref60, _api.CALL_API, {
            types: [actionTypes.UNFEATURE_ICON, actionTypes.UNFEATURE_ICON_SUCCESS, actionTypes.UNFEATURE_ICON_FAILURE],
            data: {
                icons: [{
                    id: icon_id,
                    status: "remove"
                }]
            },
            endpoint: "featured/icons/",
            method: "POST",
            service: "api"
        }), _defineProperty(_ref60, "icon_upload_id", icon_id), _ref60;
    } else {
        return {
            type: actionTypes.UNFEATURE_ICON,
            icon_upload_id: icon_id
        };
    }
}

function saveName(icon, name) {
    return {
        icon_id: icon,
        name: name,
        type: actionTypes.SAVE_NAME
    };
}

function saveTags(icon, tags) {
    return {
        icon_id: icon,
        tags: tags,
        type: actionTypes.SAVE_TAGS
    };
}

// plugin
function setAdobeAgent() {
    return {
        type: actionTypes.SET_ADOBE_AGENT
    };
}

function reportPluginUsage(iconId, host, fileType, hexColor) {
    hexColor = hexColor.replace("#", "");
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.REPORT_PLUGIN_USAGE, actionTypes.REPORT_PLUGIN_USAGE_SUCCESS, actionTypes.REPORT_PLUGIN_USAGE_FAILURE],
        data: {},
        endpoint: "plugin_report/?icon_id=" + iconId + "&host=" + host + "&file_type=" + fileType + "&hexColor=" + hexColor,
        method: "POST",
        service: "www"
    });
}

function setPage(page) {
    return {
        page: page,
        type: actionTypes.SET_PLUGIN_PAGE
    };
}

function setPluginHost(host) {
    return {
        host: host,
        type: actionTypes.SET_PLUGIN_HOST
    };
}

function placePluginPNGGSuite(icon, color, size) {
    return _defineProperty({
        apiResponse: true,
        icon: icon,
        color: color,
        imgSize: size
    }, _api.CALL_API, {
        types: [actionTypes.GET_PNG_URL, actionTypes.GET_PNG_URL_SUCCESS, actionTypes.GET_PNG_URL_FAILURE],
        data: "",
        endpoint: "get_plugin_png_token/" + icon.id + "/",
        method: "GET",
        service: "www"
    });
}

function placePluginPDF(icon, color, size) {
    return _defineProperty({
        apiResponse: true,
        icon: icon,
        imgSize: size
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_PDF_DATA, actionTypes.FETCH_PDF_DATA_SUCCESS, actionTypes.FETCH_PDF_DATA_FAILURE],
        data: "",
        endpoint: "get_plugin_icon/pdf/" + icon.id + "/" + color + "/" + size + "/",
        method: "GET",
        service: "www"
    });
}

function placePluginPNG(assetData, imgSize, host) {
    return _defineProperty({
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_PNG_DATA, actionTypes.FETCH_PNG_DATA_SUCCESS, actionTypes.FETCH_PNG_DATA_FAILURE],
        data: "",
        endpoint: "get_plugin_icon/png/" + assetData.icon_id + "/" + assetData.color + "/" + imgSize + "/",
        method: "GET",
        service: "www"
    });
}

function pluginIcons() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return _defineProperty({
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_PLUGIN_ICONS, actionTypes.FETCH_PLUGIN_ICONS_SUCCESS, actionTypes.FETCH_PLUGIN_ICONS_FAILURE],
        endpoint: "plugin_icons/" + page + "/",
        schema: Schemas.ICONS,
        method: "GET",
        service: "www"
    });
}

// edu

function sendEduApplication(applicationData) {
    return _defineProperty({
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.SEND_EDU_APPLICATION, actionTypes.SEND_EDU_APPLICATION_SUCCESS, actionTypes.SEND_EDU_APPLICATION_FAILURE],
        endpoint: "for-edu/apply/",
        method: "POST",
        data: applicationData,
        service: "www"
    });
}

// Downloads
var downloadResetFlow = exports.downloadResetFlow = function downloadResetFlow() {
    return function (dispatch, getState) {
        dispatch({
            type: actionTypes.DOWNLOAD_RESET_FLOW
        });
    };
};

var downloadSetFlowActive = exports.downloadSetFlowActive = function downloadSetFlowActive(icon) {
    return function (dispatch, getState) {
        dispatch({
            type: actionTypes.DOWNLOAD_SET_FLOW_ACTIVE,
            icon: icon
        });
        dispatch(_extends({
            type: actionTypes.FETCH_HERO_ICON_SUCCESS,
            response: {}
        }, icon));
    };
};

var downloadFlowGoBack = exports.downloadFlowGoBack = function downloadFlowGoBack() {
    return {
        type: actionTypes.DOWNLOAD_FLOW_GO_BACK
    };
};

var downloadRequest = exports.downloadRequest = function downloadRequest() {
    return function (dispatch, getState) {
        var _getState3 = getState(),
            user = _getState3.user,
            icons = _getState3.icons;

        if (!user || (0, _isEmpty2.default)(user) || !user.id) {
            user = false;
            dispatch(downloadShowAuth());
        }

        return dispatch({
            type: actionTypes.DOWNLOAD_REQUEST,
            user: user
        });
    };
};

function downloadSelectLicense(license) {
    return {
        type: actionTypes.DOWNLOAD_SELECT_LICENSE,
        license: license
    };
}

function downloadCommitLicense() {
    return {
        type: actionTypes.DOWNLOAD_COMMIT_LICENSE
    };
}

function downloadSelectAttribution(attributionType) {
    return {
        type: actionTypes.DOWNLOAD_SELECT_ATTRIBUTION,
        attributionType: attributionType
    };
}
function downloadCommitAttribution() {
    return {
        type: actionTypes.DOWNLOAD_COMMIT_ATTRIBUTION
    };
}

var downloadShowAuth = exports.downloadShowAuth = function downloadShowAuth() {
    _dispatcher2.default.dispatch({
        actionType: "loginRequired"
    });

    return {
        type: "DOWNLOAD_SHOW_AUTH"
    };
};

var downloadStart = exports.downloadStart = function downloadStart(format) {
    return function (dispatch, getState) {
        var _getState4 = getState(),
            download = _getState4.download,
            icons = _getState4.icons;

        var pendingDownload = download.pendingDownload,
            processing = download.processing,
            isPremiumUser = download.isPremiumUser,
            hasPurchased = download.hasPurchased,
            iconBaseLicense = download.iconBaseLicense;

        if (processing) {

            return;
        }

        if (!format) {
            return dispatch({
                type: actionTypes.DOWNLOAD_START_FAILURE,
                error: "Please select a format to download."
            });
        }

        var selectedColor = icons.selectedColor;

        var imgColor = void 0;
        if (selectedColor) {
            imgColor = selectedColor.hex;
        }

        var data = {
            icon_id: pendingDownload.id,
            img_type: format
        };

        var isPublicDomain = iconBaseLicense == _download.licenses.PUBLIC_DOMAIN;

        var endpoint = "icon/" + pendingDownload.id + "/download/";
        if (isPremiumUser || hasPurchased || isPublicDomain) {
            if (selectedColor) {
                var _imgColor = "000000";
                if (selectedColor.hex) {
                    var selected = selectedColor.hex.toLowerCase();
                    if (selected === "black") {
                        _imgColor = "000000";
                    } else if (selected === "white") {
                        _imgColor = "ffffff";
                    } else if (selected.indexOf("#") >= 0) {
                        _imgColor = selectedColor.hex.split("#")[1];
                    }
                }

                data.img_color = _imgColor;
                var fileUrl = "/" + endpoint + "color/" + data.img_color + "/" + data.img_type + "/";
                var _downloadType = isPremiumUser ? "Pro" : "Public Domain";
                if (hasPurchased) {
                    _downloadType = "Royalty Free";
                }
                return dispatch(downloadStartSuccess({
                    fileType: format,
                    downloadType: _downloadType,
                    imgColor: _imgColor,
                    response: {
                        download: fileUrl
                    }
                }));
            }
        }

        var downloadType = "Creative Commons";
        return dispatch((0, _callApiPromise2.default)({
            types: [actionTypes.DOWNLOAD_START, downloadStartSuccess, actionTypes.DOWNLOAD_START_FAILURE],
            endpoint: "/" + endpoint,
            method: "POST",
            data: data,
            actionPayload: {
                downloadType: downloadType,
                fileType: format,
                icon: pendingDownload.id
            }
        })).catch(function (error) {
            var code = error && error.status || "";
            _raven_client2.default.captureMessage(downloadType + " Download failed " + code, {
                extra: {
                    iconId: pendingDownload.id,
                    data: data,
                    endpoint: endpoint,
                    error: JSON.stringify(error)
                }
            });
        });
    };
};

var downloadStartSuccess = exports.downloadStartSuccess = function downloadStartSuccess(_ref67) {
    var response = _ref67.response,
        downloadType = _ref67.downloadType,
        imgColor = _ref67.imgColor,
        fileType = _ref67.fileType;
    return function (dispatch, getState) {
        dispatch({
            type: actionTypes.DOWNLOAD_START_SUCCESS,
            fileType: fileType,
            downloadType: downloadType,
            imgColor: imgColor,
            response: response
        });

        var downloadUrl = response.download;

        var _getState5 = getState(),
            download = _getState5.download;

        var pendingDownload = download.pendingDownload;
        var name = pendingDownload.name,
            id = pendingDownload.id;


        var fileName = "noun_" + name + "_" + id;
        if (imgColor) {
            fileName = fileName + "_" + imgColor;
        }
        fileName = fileName + "." + fileType;

        var error = null;
        var finished = (0, _download3.default)(downloadUrl, fileName);
        if (finished.then) {
            return finished.then(function () {
                dispatch({
                    type: actionTypes.DOWNLOAD_COMPLETE_SUCCESS,
                    downloadType: downloadType,
                    fileType: fileType,
                    icon: id
                });
            }).catch(function (error) {
                dispatch({
                    type: actionTypes.DOWNLOAD_COMPLETE_FAILURE,
                    error: error,
                    downloadType: downloadType,
                    fileType: fileType,
                    icon: id
                });
                var code = error && error.status || "";
                var message = downloadType + " Download failed " + code;
                _raven_client2.default.captureMessage(message, {
                    extra: {
                        iconId: id,
                        fileName: fileName,
                        downloadUrl: downloadUrl,
                        error: error
                    }
                });
            });
        } else {
            dispatch({
                type: actionTypes.DOWNLOAD_COMPLETE_SUCCESS,
                downloadType: downloadType,
                fileType: fileType,
                icon: id
            });
        }
    };
};

var downloadPurchase = exports.downloadPurchase = function downloadPurchase(stripeApi) {
    return function (dispatch, getState) {
        var _getState6 = getState(),
            stripe = _getState6.stripe,
            download = _getState6.download,
            user = _getState6.user;

        var pendingDownload = download.pendingDownload,
            processing = download.processing;

        if (processing) {
            return;
        }

        var iconId = pendingDownload.id;
        var stripeToken = stripe.stripeToken,
            currentPurchase = stripe.currentPurchase,
            saveCard = stripe.saveCard,
            savedCard = stripe.savedCard,
            useNewCard = stripe.useNewCard,
            billingInfo = stripe.billingInfo;


        if (!currentPurchase) {
            return dispatch(downloadPurchaseEnd("Please select a license."));
        }

        var isAlaCarte = !currentPurchase.period;
        var isSubscription = !!currentPurchase.period;

        var getToken = void 0;
        if (savedCard && !useNewCard) {
            getToken = Promise.resolve();
        } else {
            if (!stripeApi) {
                return dispatch(downloadPurchaseEnd("Please enter a payment method."));
            }
            getToken = dispatch(stripeCreateToken(stripeApi));
        }

        var didUpdateSavedCard = void 0;
        dispatch(downloadPurchaseStart());
        return getToken.then(function (stripeResponse) {
            if (stripeResponse) {
                var token = stripeResponse.token;

                return token.id;
            }
        }).then(function (token) {
            var updateBillingInfo = void 0;
            if (billingInfo) {
                updateBillingInfo = billingInfo;
            }

            var updateToken = void 0;
            if (token && isAlaCarte && saveCard || isSubscription) {
                updateToken = token;
            }

            if (updateToken || updateBillingInfo) {
                var endpoint = "/" + user.username + "/card/update/";
                var data = {
                    stripe_token: updateToken,
                    receipt_info: updateBillingInfo
                };

                return dispatch((0, _callApiPromise2.default)({
                    method: "post",
                    types: [actionTypes.SAVE_CARD, actionTypes.SAVE_CARD_SUCCESS, actionTypes.SAVE_CARD_FAILURE],
                    data: data,
                    endpoint: endpoint
                })).then(function (response) {
                    // Only pass the token through if not saving card
                    if (!updateToken) {
                        return token;
                    } else {
                        didUpdateSavedCard = true;
                    }
                }).catch(function (error) {
                    // /card/update returns weird errors
                    return Promise.reject("Something went wrong trying to save your card, you have not been charged.");
                });
            }
            return token;
        }).then(function (token) {
            var data = {};

            if (token) {
                data.stripe_token = token;
            }

            var endpoint = void 0;
            if (isAlaCarte) {
                endpoint = "/icon/" + iconId + "/purchase/";
            } else {
                data.plan = currentPurchase.type + "-" + currentPurchase.period;
                endpoint = "/" + user.username + "/subscribe/pro/";
            }

            return dispatch((0, _callApiPromise2.default)({
                endpoint: endpoint,
                data: data,
                method: "post",
                types: [actionTypes.DOWNLOAD_PURCHASE, actionTypes.DOWNLOAD_PURCHASE_SUCCESS, actionTypes.DOWNLOAD_PURCHASE_FAILURE],
                actionPayload: {
                    purchase: currentPurchase
                }
            }));
        }).then(function () {
            dispatch(downloadPurchaseEnd());
        }).catch(function (error) {
            if (error) {
                if (error.statusText) {
                    error = error.statusText;
                } else if (error.error && error.error.message) {
                    error = error.error.message;
                }
            }

            dispatch(downloadPurchaseEnd(error));
        }).then(function () {
            if (didUpdateSavedCard) {
                return dispatch(stripeGetSavedCard());
            }
        });
    };
};

var downloadSelectPurchaseType = exports.downloadSelectPurchaseType = function downloadSelectPurchaseType(purchaseTypeKey) {
    return function (dispatch, getState) {
        var _getState7 = getState(),
            download = _getState7.download,
            stripe = _getState7.stripe;

        if (download.processing || stripe.processing) {
            return;
        }

        return dispatch({
            type: actionTypes.DOWNLOAD_SELECT_PURCHASE_TYPE,
            purchaseTypeKey: purchaseTypeKey
        });
    };
};

var downloadUpsellFlow = exports.downloadUpsellFlow = function downloadUpsellFlow(icon) {
    return function (dispatch, getState) {
        var _getState8 = getState(),
            download = _getState8.download;

        var attributionType = download.attributionType,
            purchaseTypeKey = download.purchaseTypeKey,
            status = download.status;


        var confirmed = dispatch(showModal(null, "DOWNLOAD_UPSELL", {
            icon: icon
        }));

        confirmed.then(function (result) {
            if (result == _download.NO_PREMIUM_FEATURES) {
                dispatch(downloadNoPremiumFeatures());
                dispatch(downloadResetToLicense(icon, _download.licenses.CREATIVE_COMMONS));
                if (attributionType) {
                    dispatch(downloadSelectAttribution(attributionType));
                    if (status == _download.phases.DOWNLOAD_READY) {
                        dispatch(downloadCommitAttribution());
                    }
                }
            } else if (result == _download.YES_DO_UPSELL) {
                dispatch(downloadUpsell(icon));
                if (purchaseTypeKey) {
                    dispatch(downloadSelectPurchaseType(purchaseTypeKey));
                }
            }

            return result;
        });

        return confirmed;
    };
};

var downloadResetToLicense = exports.downloadResetToLicense = function downloadResetToLicense(icon, license) {
    return function (dispatch, getState) {
        dispatch(downloadResetFlow());
        dispatch(downloadSetFlowActive(icon));
        dispatch(downloadRequest());
        dispatch(downloadSelectLicense(license));
        dispatch(downloadCommitLicense());
    };
};
var downloadUpsell = exports.downloadUpsell = function downloadUpsell(icon) {
    return function (dispatch, getState) {
        dispatch({
            type: actionTypes.DOWNLOAD_UPSELL
        });
        dispatch(downloadResetToLicense(icon, _download.licenses.ROYALTY_FREE));
    };
};

var downloadRepurchase = exports.downloadRepurchase = function downloadRepurchase(icon) {
    return function (dispatch, getState) {
        dispatch(downloadResetFlow());
        dispatch({
            type: actionTypes.DOWNLOAD_REPURCHASE
        });
        dispatch(downloadSetFlowActive(icon));
        dispatch(downloadRequest());
        dispatch(downloadSelectLicense(_download.licenses.ROYALTY_FREE));
        dispatch(downloadCommitLicense());
        dispatch(downloadSelectPurchaseType("alacarte"));
    };
};

var downloadJumpToLicense = exports.downloadJumpToLicense = function downloadJumpToLicense(license) {
    return function (dispatch, getState) {
        var _getState9 = getState(),
            download = _getState9.download;

        if (download.processing) {
            return;
        }

        var usingPremiumFeatures = download.usingPremiumFeatures;


        var icon = download.pendingDownload;

        dispatch({
            type: actionTypes.DOWNLOAD_JUMP_TO_LICENSE,
            license: license
        });

        if (usingPremiumFeatures && license == _download.licenses.CREATIVE_COMMONS) {
            dispatch(downloadUpsellFlow(icon));
        } else {
            dispatch(downloadResetToLicense(icon, license));
        }
    };
};

var downloadResetAttribution = exports.downloadResetAttribution = function downloadResetAttribution() {
    return function (dispatch, getState) {
        var _getState10 = getState(),
            download = _getState10.download;

        if (download.processing) {
            return;
        }

        var icon = download.pendingDownload;

        dispatch(downloadResetToLicense(icon, _download.licenses.CREATIVE_COMMONS));
    };
};

var downloadNoPremiumFeatures = exports.downloadNoPremiumFeatures = function downloadNoPremiumFeatures(icon) {
    return function (dispatch, getState) {
        dispatch(setColor({
            selectedColor: {
                hex: "#000000"
            }
        }));
    };
};

var downloadSetPreviewAttribution = exports.downloadSetPreviewAttribution = function downloadSetPreviewAttribution(iconId, value) {
    if (value.target) {
        value = value.target.type === "checkbox" ? value.target.checked : value;

        if (value !== true && value !== false) {
            value = null;
        }
    }
    return {
        type: actionTypes.DOWNLOAD_SET_PREVIEW_ATTRIBUTION,
        iconId: iconId,
        value: value
    };
};

function downloadPurchaseStart() {
    return {
        type: actionTypes.DOWNLOAD_PURCHASE_START
    };
}

function downloadPurchaseEnd(error) {
    return {
        type: actionTypes.DOWNLOAD_PURCHASE_END,
        error: error
    };
}

// Stripe for icon purchases

function stripeCreateTokenStart() {
    return {
        type: actionTypes.STRIPE_CREATE_TOKEN
    };
}

function stripeCreateTokenSuccess(payload) {
    return {
        type: actionTypes.STRIPE_CREATE_TOKEN_SUCCESS,
        payload: payload
    };
}

function stripeCreateTokenFailure(error) {
    return {
        type: actionTypes.STRIPE_CREATE_TOKEN_FAILURE,
        error: error
    };
}

var stripeCreateToken = exports.stripeCreateToken = function stripeCreateToken(stripe) {
    return function (dispatch) {
        dispatch(stripeCreateTokenStart());
        return stripe.createToken().then(function (payload) {
            if (payload.error) {
                return Promise.reject(payload.error);
            }
            dispatch(stripeCreateTokenSuccess(payload));
            return payload;
        }).catch(function (error) {
            dispatch(stripeCreateTokenFailure(error));
            return Promise.reject(error);
        });
    };
};

function stripeCardInputChange() {
    return {
        type: actionTypes.STRIPE_CARD_INPUT_CHANGE
    };
}

function stripeCardInputError(error) {
    if (error && error.message) {
        error = error.message;
    }

    return {
        type: actionTypes.STRIPE_CARD_INPUT_ERROR,
        error: error
    };
}

var stripeSaveCardChange = exports.stripeSaveCardChange = function stripeSaveCardChange(value) {
    return function (dispatch, getState) {
        var _getState11 = getState(),
            download = _getState11.download,
            stripe = _getState11.stripe;

        if (download.processing || stripe.processing) {
            return;
        }

        return dispatch({
            type: actionTypes.STRIPE_SAVE_CARD_CHANGE,
            value: value
        });
    };
};

var stripeGetSavedCard = exports.stripeGetSavedCard = function stripeGetSavedCard() {
    return function (dispatch) {
        var endpoint = "/get/customer/";

        return dispatch((0, _callApiPromise2.default)({
            types: [actionTypes.STRIPE_GET_SAVED_CARD, actionTypes.STRIPE_GET_SAVED_CARD_SUCCESS, actionTypes.STRIPE_GET_SAVED_CARD_FAILURE],
            endpoint: endpoint,
            method: "GET"
        }));
    };
};

var stripeUseNewCard = exports.stripeUseNewCard = function stripeUseNewCard() {
    return function (dispatch, getState) {
        var _getState12 = getState(),
            download = _getState12.download,
            stripe = _getState12.stripe;

        if (download.processing || stripe.processing) {
            return;
        }

        return dispatch({
            type: actionTypes.STRIPE_USE_NEW_CARD
        });
    };
};

var stripeUpdateBillingInfo = exports.stripeUpdateBillingInfo = function stripeUpdateBillingInfo(value) {
    return function (dispatch, getState) {
        var _getState13 = getState(),
            download = _getState13.download,
            stripe = _getState13.stripe;

        if (download.processing || stripe.processing) {
            return;
        }

        return dispatch({
            type: actionTypes.STRIPE_UPDATE_BILLING_INFO,
            value: value
        });
    };
};

// UI
var uiScrollToElement = exports.uiScrollToElement = function uiScrollToElement(el) {
    if (el) {
        var scrollToEl = (0, _jquery2.default)(el);
        if (scrollToEl.length) {
            var contentOffset = (0, _jquery2.default)("#main-content").offset().top + 1;
            var scrollTo = scrollToEl.offset().top - contentOffset;

            (0, _jquery2.default)("html,body").scrollTop(scrollTo);
        } else {
            console.warn("scroll to element not found", el);
        }
    }

    return {
        type: actionTypes.UI_SCROLL_TO_ELEMENT,
        element: el && (el.id || el.getAttribute("class"))
    };
};

var uiBodyClassAdd = exports.uiBodyClassAdd = function uiBodyClassAdd() {
    for (var _len = arguments.length, classes = Array(_len), _key = 0; _key < _len; _key++) {
        classes[_key] = arguments[_key];
    }

    if (classes && classes.length) {
        var _global$document$body;

        (_global$document$body = global.document.body.classList).add.apply(_global$document$body, classes);
    }
    return {
        type: actionTypes.UI_BODY_CLASS_ADD,
        classes: classes
    };
};

var uiBodyClassRemove = exports.uiBodyClassRemove = function uiBodyClassRemove() {
    for (var _len2 = arguments.length, classes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        classes[_key2] = arguments[_key2];
    }

    var toRemove = [];
    if (classes && classes.length == 1 && (0, _isRegExp2.default)(classes[0])) {
        var needle = classes[0];

        var classList = global.document.body.classList;

        if (!classList.forEach) {
            classList = [].slice.call(classList);
        }

        classList.forEach(function (cl) {
            if (needle.test(cl)) {
                toRemove.push(cl);
            }
        });
    } else {
        toRemove = classes;
    }

    if (toRemove.length) {
        var _global$document$body2;

        (_global$document$body2 = global.document.body.classList).remove.apply(_global$document$body2, _toConsumableArray(toRemove));
    }

    return {
        type: actionTypes.UI_BODY_CLASS_REMOVE,
        toRemove: toRemove
    };
};

var experimentsSet = exports.experimentsSet = function experimentsSet(experiments) {
    return {
        type: actionTypes.EXPERIMENTS_SET,
        experiments: experiments
    };
};